import { getWorkChatLocation, isInWorkChat } from './native'
import { setLoading } from './helper'
import { getLocation } from 'bs-sdk'

export interface LocationType {
  cityId: string
  cityName: string
  lat: string
  lng: string
  adcode: string
  [prod: string]: any
}

/**
 *
 * @param hasLoading 是否有loading默认有
 */
export async function getPosition(
  hasLoading = true,
  cache = 30
): Promise<LocationType | null> {
  let position: LocationType | null = null
  if (hasLoading) setLoading()
  try {
    if (isInWorkChat()) {
      position = await getWorkChatLocation()
    } else {
      position = await getLocation(cache)
    }
  } catch (error) {
    console.log(error)
  } finally {
    if (hasLoading) setLoading(false)
  }
  console.log('获取定位', position)
  return position
}
